// extracted by mini-css-extract-plugin
module.exports = {"sidebarButton":"_5S-LR","collapsed":"JloSW"};